import { render, staticRenderFns } from "./GroupMeetings.vue?vue&type=template&id=64650928&"
import script from "./GroupMeetings.vue?vue&type=script&lang=js&"
export * from "./GroupMeetings.vue?vue&type=script&lang=js&"
import style0 from "./GroupMeetings.vue?vue&type=style&index=0&id=64650928&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports